var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pf23-inFo-wrap" },
      [
        _vm.mainResponses
          ? _c(
              "div",
              { staticClass: "widM clearfix" },
              [
                _vm._l(_vm.mainResponses, function(mainAttendant, idx) {
                  return [
                    _c("SurveyParticipant", {
                      key: "mainAttendant" + idx,
                      attrs: { seq: idx, participant: mainAttendant }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      key: "mainAttendant_span" + idx,
                      staticClass: "disIb moOnly",
                      staticStyle: { padding: "2.5px" }
                    }),
                    _vm._v(" "),
                    idx < _vm.mainResponses.length - 1
                      ? _c("hr", {
                          key: "mainAttendant_hr" + idx,
                          staticClass: "moOnly",
                          staticStyle: {
                            "border-top": "1px solid #ddd",
                            background: "#f4f4f4",
                            padding: "5px 0"
                          }
                        })
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("SurveyParticipantFloat", {
          attrs: {
            infoAvailable: _vm.infoAvailable,
            title: "안전 확인",
            description:
              "‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)",
            sqCode: "Q119",
            tooltip: true,
            tooltipMessage:
              "* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에 작성하여 주시기 바랍니다.",
            isRequired: true
          }
        }),
        _vm._v(" "),
        _c("SurveyParticipantFloat", {
          attrs: {
            infoAvailable: _vm.infoAvailable,
            title: "알러지 및 식단 확인",
            description:
              "알러지 또는 유의해야할 식단이 있습니까? 있다면 어떤 것인지 적어주십시오.",
            sqCode: "Q120",
            tooltip: false,
            isRequired: false
          }
        }),
        _vm._v(" "),
        _c("SurveyParticipantFloat", {
          attrs: {
            infoAvailable: _vm.infoAvailable,
            title: "VISA 발급 여부 ",
            description: "ETA(전자여행허가)를 신청하셨습니까?",
            sqCode: "Q121",
            tooltip: false,
            isRequired: true
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTML pf23-subTit" }, [
      _c(
        "div",
        {
          staticClass: "widM fntH4 bold padTS padBS",
          staticStyle: { color: "#fff" }
        },
        [_vm._v("참가자 정보")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM padTSM" }, [
      _c(
        "ul",
        {
          staticClass: "osResNoticeList fntE colorGray",
          staticStyle: { "padding-left": ".5em", "text-indent": "-.5em" }
        },
        [
          _c("li", [
            _vm._v("- "),
            _c("em", { staticStyle: { color: "#e11e45" } }, [_vm._v("*")]),
            _vm._v(" 표시는 필수 입력사항입니다.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "- 첨부파일은 JPG, PNG, PDF, HEIC, HEIF 형식으로 최대 10MB까지 등록하실 수 있습니다."
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5580a799", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5580a799","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sydney/components/SurveyParticipantInfo.vue
// module id = null
// module chunks = 